
interface NavigationProps {
  isScrolled: boolean;
  isDarkNav: boolean;
}

export default function Navigation({ isScrolled, isDarkNav }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const navItems = [
    { id: 'hero', label: 'Start' },
    { id: 'la-gomera', label: 'La Gomera' },
    { id: 'hotel', label: 'Hotel' },
    { id: 'dojazd', label: 'Dojazd' },
    { id: 'golf', label: 'Golf' },
    { id: 'eco-finca', label: 'Eco Finca' },
    { id: 'pokoje', label: 'Pokoje' },
    { id: 'relaks', label: 'Relaks' },
    { id: 'b2b', label: 'B2B' },
    { id: 'kontakt', label: 'Kontakt' }
  ];

  const navBg = !isScrolled ? 'bg-transparent' : 'bg-white shadow-md';
  const textColor = isDarkNav ? 'text-white' : 'text-stone-700';
  const hoverColor = isDarkNav ? 'hover:bg-white/10' : 'hover:bg-stone-100';
  const logoBg = !isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-lg' : 'bg-transparent';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className={`flex items-center gap-4 px-5 py-3 rounded-lg transition-all duration-300 ${logoBg}`}>
            <img 
              src="https://static.readdy.ai/image/2f500271175ac97b037b5e94d69334e6/d3f566fff327433480db44ef3a925506.png" 
              alt="Meet Hiszpania" 
              className="h-20 w-auto"
            />
            <div className="border-l border-stone-300 h-16"></div>
            <div className="flex flex-col">
              <span className="text-xs text-stone-500 font-medium">Projekt Meet Hiszpania dla</span>
              <span className="text-sm font-semibold text-stone-800">Hotel Jardín Tecina</span>
            </div>
          </div>
          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap rounded-md ${textColor} ${hoverColor} hover:text-stone-900 cursor-pointer`}
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
}